
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useEnhancedColorThemes } from "@/hooks/useEnhancedColorThemes";

interface Character {
  id: string;
  name: string;
  species: string;
  role: string;
  description: string;
  personality: string;
  teaching_focus: string;
  special_talents: string;
  fun_facts: any;
  image_url: string;
  avatar_url: string;
  color_theme: string;
  age_group: string;
  featured: boolean;
}

interface CharacterCallToActionProps {
  character: Character;
}

export const CharacterCallToAction = ({ character }: CharacterCallToActionProps) => {
  const { getEnhancedTheme } = useEnhancedColorThemes();
  const enhancedTheme = getEnhancedTheme(character.color_theme);

  return (
    <Card 
      className="text-white"
      style={{
        background: `linear-gradient(to right, ${enhancedTheme.gradientColors.to}, ${enhancedTheme.gradientColors.from})`
      }}
      role="complementary" 
      aria-label="Call to action"
    >
      <CardContent className="p-8 text-center">
        <h2 className="text-3xl font-bold mb-4">
          Meet {character.name} in Our Episodes!
        </h2>
        <p className="text-xl mb-8 opacity-90 max-w-2xl mx-auto">
          Watch {character.name} in action and learn about Cayman Islands culture through fun adventures.
        </p>
        <Button asChild size="lg" variant="secondary" className="bg-white text-gray-800 hover:bg-gray-100">
          <Link to="/episodes" aria-label="Go to episodes page to watch videos">
            Watch Episodes
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
};
